module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"done":"Done","link":"Link","status":"Status","startedAt":"Started:","viewError":"View error"}}')
  delete Component.options._Ctor
}
